// Script para reemplazar el texto "Ovah Access" con un logo de forma permanente
document.addEventListener('DOMContentLoaded', function() {
  // Función para reemplazar el texto con el logo
  function replaceWithLogo(heading) {
    if (heading && heading.textContent === 'Ovah Access','ovah') {
      // Verificar si ya contiene una imagen
      if (heading.querySelector('img')) return;
      
      // Crea el elemento de imagen para el logo
      const logoImg = document.createElement('img');
      logoImg.src = 'https://cdn.shopify.com/s/files/1/0662/5434/0252/files/OVAH_ACCESS_BANNER_1000_x_250_px_800_x_100_px_1.png?v=1747412479';
      logoImg.alt = 'Ovah Access Logo';
      logoImg.style.maxHeight = '40px';
      logoImg.style.display = 'block';
logoImg.style.marginLeft = 'auto';
logoImg.style.marginRight = 'auto';
      
      // Limpia el contenido actual y agrega el logo
      heading.textContent = '';
      heading.appendChild(logoImg);
      console.log('Logo reemplazado');
    }
  }
  
  // Ejecutar inicialmente para elementos existentes
  const headings = document.querySelectorAll('.Typography__Heading2-sc-1jyzc24-9.fZusfH.kl-hub-text.kl-hub-heading.kl-hub-h2');
  headings.forEach(replaceWithLogo);

  // Configurar un MutationObserver que seguirá ejecutándose indefinidamente
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Verificar si se añadieron nuevos nodos
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          
          // Si es un elemento del DOM (no texto)
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Buscar dentro del nuevo nodo
            if (node.querySelector) {
              const headings = node.querySelectorAll('.Typography__Heading2-sc-1jyzc24-9.fZusfH.kl-hub-text.kl-hub-heading.kl-hub-h2');
              headings.forEach(replaceWithLogo);
            }
            
            // Verificar si el propio nodo es el heading que buscamos
            if (node.matches && node.matches('.Typography__Heading2-sc-1jyzc24-9.fZusfH.kl-hub-text.kl-hub-heading.kl-hub-h2')) {
              replaceWithLogo(node);
            }
          }
        }
      }
      
      // También verificar modificaciones de contenido de texto
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        const parent = mutation.target.parentNode;
        if (parent && parent.matches && parent.matches('.Typography__Heading2-sc-1jyzc24-9.fZusfH.kl-hub-text.kl-hub-heading.kl-hub-h2')) {
          replaceWithLogo(parent);
        }
      }
    });
  });
  
  // Configurar el observer para observar TODAS las modificaciones del DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
  
  // Adicionalmente, establecer un intervalo de verificación de respaldo
  setInterval(function() {
    const headings = document.querySelectorAll('.Typography__Heading2-sc-1jyzc24-9.fZusfH.kl-hub-text.kl-hub-heading.kl-hub-h2');
    headings.forEach(replaceWithLogo);
  }, 1000); // Verificar cada segundo
});